<template>
  <v-container>
    <v-tabs grow v-if="item">
      <v-tab :to="{name: 'domain-schedule'}">
          Details
        </v-tab>
        <v-tab :to="{name: 'domain-visitors'}">
          Visitors
        </v-tab>
        <v-tab :to="{name: 'domain-products'}">
          Products
        </v-tab>
    </v-tabs>
    <router-view />
    </v-container>
</template>

<script>

  import { mapState } from "vuex";
  import ParseRoute from "@/mixins/parse-route";

  export default {
    name: 'Domain',
    mixins: [ParseRoute],
    data() {
      return {
      };
    },
    computed: {
      ...mapState('domains', ['item'])
    },
    methods: {
      loadDomain() {
          this.$store.dispatch('domains/get', { id: this.domain });
      },
    },
    created() {
      this.loadDomain();
    }
  }
</script>
